/**
 * Defines the watchers related to Primary Navigation bar feature.
 * These watchers will be imported in store/RootSaga.js
 */

import { takeLatest, all } from 'redux-saga/effects';
import { NOTIFICATIONS_GET_MSGS, NOTIFICATIONS_MARK_ARCHIVE, REVOKE_ACCESS_TOKEN } from '../../constants/ActionTypes';
import { getMessagesSaga, archiveMsgSaga, revokeAccessTokenSaga } from './Notifications.saga';

export default function* watchers() {
  return yield all([
    takeLatest(NOTIFICATIONS_GET_MSGS, getMessagesSaga),
    takeLatest(NOTIFICATIONS_MARK_ARCHIVE, archiveMsgSaga),
    takeLatest(REVOKE_ACCESS_TOKEN, revokeAccessTokenSaga),
  ]);
}
